export const getMatchingOptionsFromMandatoryOptsString = (mandatoryOptionsStr: string, lcdv16: string): string[] => {
    mandatoryOptionsStr = mandatoryOptionsStr?.replace?.(/\s/g, '') ?? '';
    if (!mandatoryOptionsStr.includes(':')) {
        // AQ05,UB01,WY05
        return mandatoryOptionsStr.split(',');
    } else {
        // 1P??????????????:AQ05,UB01;1PA?????????????:WY05
        return mandatoryOptionsStr
            .split(';')
            .map((lcdvMaskOpts: string) => lcdvMaskOpts.split(':'))
            .map(([lcdvMask, opts]) => [new RegExp(lcdvMask.replace(/\?/g, '.')), opts.split(',')])
            .reduce<string[]>(
                (optionsIdsAcc, [lcdvRegex, opts]) =>
                    (lcdvRegex as RegExp).test(lcdv16) ? [...optionsIdsAcc, ...(opts as string[])] : optionsIdsAcc,
                []
            );
    }
};
